export default "__VITE_ASSET__DYf292Co__"